import React from 'react';
import { Layout } from '../components/Layout';
import { About } from '../components/About';
export function AboutPage() {
  return <Layout data-id="element-145">
      <div className="py-12" data-id="element-146">
        <About data-id="element-147" />

        {/* Additional About Content */}
        <section className="py-16 bg-gray-50" data-id="element-148">
          <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-4xl" data-id="element-149">
            <h3 className="text-2xl font-heading font-bold text-brand-navy mb-6 text-center" data-id="element-150">
              Notre Histoire
            </h3>
            <div className="prose prose-lg mx-auto text-gray-600" data-id="element-151">
              <p className="mb-4" data-id="element-152">
                Fondée avec la vision de simplifier l'approvisionnement pour
                tous, AVENIR 2000 s'est rapidement imposée comme un acteur
                incontournable du marché. Notre engagement envers l'excellence
                et la satisfaction client guide chacune de nos décisions.
              </p>
              <p className="mb-4" data-id="element-153">
                Nous avons bâti un réseau solide de partenaires et de
                fournisseurs, nous permettant de vous offrir des produits de la
                plus haute qualité à des prix défiant toute concurrence.
              </p>
              <p data-id="element-154">
                Aujourd'hui, nous continuons d'innover et d'élargir notre
                catalogue pour répondre à vos besoins changeants, tout en
                conservant les valeurs qui ont fait notre succès : intégrité,
                fiabilité et service exceptionnel.
              </p>
            </div>
          </div>
        </section>
      </div>
    </Layout>;
}